import { Link } from "react-router-dom"

import { MetaData } from "@/domains/common/layout/metadata"
import { PageContainer } from "@/domains/common/layout/page-container"
import { PageTitle } from "@/domains/common/layout/page-title"

const DesignPage = () => {
  return (
    <PageContainer>
      <MetaData title="Design" />
      <PageTitle title="Design" subTitle="Our design system and components" />

      <div className="text-t100 flex flex-col gap-4">
        <Link to="/design/design-system" className="hover:text-p100-light">
          Design System
        </Link>
        <Link to="/design/design-palette" className="hover:text-p100-light">
          Design Palette
        </Link>
        <Link to="/design/components">Components</Link>
        <Link to="/design/ui-system">UI System</Link>
        <Link to="/design/typography">Typography</Link>
      </div>
    </PageContainer>
  )
}

export default DesignPage
